import React from "react";
import Switch from "react-ios-switch";

class SwitchField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({ checked });
    this.props.input.onChange(checked);
  }

  render() {
    const { checked } = this.state;
    return (
      <div>
        <Switch
          checked={this.props.input.value || 0}
          className="switch"
          disabled={undefined}
          handleColor="white"
          name="colour"
          offColor="white"
          onChange={checked => this.handleChange(checked)}
          onColor="rgb(76, 217, 100)"
          pendingOffColor={undefined}
          pendingOnColor={undefined}
          readOnly={undefined}
          style={undefined}
        />
      </div>
    );
  }
}

export default SwitchField;



// WEBPACK FOOTER //
// ./src/system/fields/Switch/index.jsx